/* global front-end constants (single source of truth) */

export const SITE_URL = 'https://greatlysocial.com'

/* AI Studio → AI Bulk Post Creation (/dashboard/studio/bulk) opens in this
   mode: 'form' (step-by-step wizard) or 'chat' (guided AI Post Creator chat).
   Both stay reachable from the switch on the page. 'chat' since T38, after
   the live chat eval (backend/scripts/chat-eval.js --live) passed. */
export const AI_STUDIO_DEFAULT_MODE = 'chat'

/* Sidebar 'NEW' badges: shown for NEW_BADGE_DAYS after a feature launches. */
export const NEW_BADGE_DAYS = 30
export const ANALYTICS_LAUNCH_DATE = '2026-10-23'   // Social Media › Analytics (Part E, T29)
export const isNewFeature = (launchDate, now = Date.now()) => {
  const start = Date.parse(`${launchDate}T00:00:00Z`)
  return now >= start && now < start + NEW_BADGE_DAYS * 24 * 60 * 60 * 1000
}
